/* byLivia — landing pages : simulateur de prénom, date de livraison, filtres, barre fixe.
   Le prénom saisi suit le client jusqu'à la fiche produit (byliviaPerso.remember / handoff). */
(function () {
  'use strict';

  var lastPlaqueId = null;

  /* ---------- Jours fériés français (fixes + mobiles) ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  function holidays(y) {
    var e = easter(y), list = [[1, 1], [5, 1], [5, 8], [7, 14], [8, 15], [11, 1], [11, 11], [12, 25]].map(function (md) { return new Date(y, md[0] - 1, md[1]); });
    [1, 39, 50].forEach(function (off) { var d = new Date(e); d.setDate(d.getDate() + off); list.push(d); });
    return list.map(function (d) { return d.toDateString(); });
  }
  function addBusinessDays(from, n) {
    var d = new Date(from), c = 0, hol = holidays(d.getFullYear()).concat(holidays(d.getFullYear() + 1));
    while (c < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && hol.indexOf(d.toDateString()) === -1) c++;
    }
    return d;
  }
  /* Date de commande pour les délais : aujourd'hui, ou le jour « base » si l'atelier est en congés
     (snippet atelier-conges, window.byliviaConges). */
  function orderDate() {
    var now = new Date(), cg = window.byliviaConges;
    return cg && cg.base && now < cg.base ? new Date(cg.base) : now;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  /* ---------- Simulateur ---------- */
  /* Anciennes clés de style (avant le personnalisateur maison) → styles actuels. */
  var FONT_ALIAS = { bold: 'anton', caps: 'bebas', script: 'kaushan', elegant: 'kaushan', light: 'anton' };

  function initHero(root) {
    var P = window.byliviaPerso;
    var shipDays = parseInt(root.getAttribute('data-ship-days') || '2', 10);
    var transitDays = parseInt(root.getAttribute('data-transit-days') || '3', 10);
    var maxLen = parseInt(root.getAttribute('data-max-length') || '14', 10);
    var input = root.querySelector('[data-name-input]');
    var overlay = root.querySelector('[data-name-overlay]');
    var stage = root.querySelector('[data-stage]');
    var note = root.querySelector('[data-fit-note]');
    var plaques = Array.prototype.slice.call(root.querySelectorAll('[data-plaque]'));
    var plaqueChips = Array.prototype.slice.call(root.querySelectorAll('[data-plaque-chip]'));
    var fontChips = Array.prototype.slice.call(root.querySelectorAll('[data-font-chip]'));
    var goLinks = Array.prototype.slice.call(document.querySelectorAll('[data-landing-go]'));
    var ctx = document.createElement('canvas').getContext('2d');
    var defaultDemo = overlay ? overlay.getAttribute('data-placeholder') || '' : '';
    var eyebrow = root.querySelector('[data-hero-eyebrow]');
    var modelLine = root.querySelector('[data-model-line]');
    var modelPrice = root.querySelector('[data-model-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyDefault = stickyPrice ? stickyPrice.textContent : '';
    var defFont = root.getAttribute('data-default-font') || 'kaushan';
    if (P && !P.FONTS[defFont]) defFont = FONT_ALIAS[defFont] || 'kaushan';
    var current = { plaque: null, font: defFont, cfg: null };
    /* Parcours gravure (data-flow="grave", variante A) : la pointe écrit le prénom (P.writer) ;
       une fois un prénom tapé, « Choisissez votre gourmette » descend aux modèles, qui l'affichent
       tous (évènement bylivia:name, voir initModelsName). Classe lg-name sur <html> = prénom tapé. */
    var grave = root.getAttribute('data-flow') === 'grave';
    var writer = grave && P && P.writer && stage && overlay ? P.writer(stage, overlay) : null;
    var fontsReady = false;
    var wState = { text: '', font: '', plaque: null };
    var chooseBtn = root.querySelector('[data-name-choose]');

    /* Le client revient d'une fiche produit : on lui rend le texte qu'il avait tapé. */
    if (input && !input.value && P && P.handoff) {
      var back = P.handoff();
      if (back.text) {
        input.value = back.text.slice(0, maxLen);
        if (back.font) current.font = back.font;
      }
    }

    function currentName() {
      var v = input ? input.value : '';
      if (P) v = P.sanitize(v);
      return v.replace(/\s+/g, ' ').trim().slice(0, maxLen);
    }
    /* Rendu « maison » : même moteur, même photo de plaque et mêmes cotes que la fiche produit. */
    function paintPerso(raw) {
      var f = P.FONTS[current.font] || P.FONTS.kaushan;
      var d = P.dims(current.cfg);
      var shown = P.normalize(raw || (overlay ? overlay.getAttribute('data-placeholder') : '') || '', current.font);
      var r = P.fit(ctx, shown, f.css, d.zoneW, d.zoneH, d.ppm);
      P.placeText(
        { stage: stage, overlay: overlay, img: current.plaque.querySelector('img') },
        current.cfg.preview || {}, d, r, f, shown
      );
      if (overlay) overlay.classList.toggle('is-placeholder', !raw);
      if (writer) {
        var mode;
        if (!fontsReady) mode = 'hide';
        else if (shown === wState.text && current.font === wState.font && current.plaque === wState.plaque) mode = 'none';
        else if (!wState.text || current.plaque !== wState.plaque) mode = 'demo';
        else if (current.font !== wState.font) mode = 'font';
        else if (raw) mode = 'type';
        else mode = 'demo';
        if (mode !== 'hide') { wState.text = shown; wState.font = current.font; wState.plaque = current.plaque; }
        writer.write(shown, mode);
      }
      /* Même règle de lisibilité que la fiche : on prévient ici plutôt que de décevoir là-bas. */
      if (note) {
        var tooSmall = !!raw && r.capMm < d.minMm;
        note.hidden = !tooSmall;
        if (tooSmall) note.textContent = 'Un peu long pour cette gourmette : raccourcissez, changez de style, ou choisissez un modèle à plaque plus large.';
      }
      /* Seul ce que le client a tapé le suit sur les fiches : le prénom d'exemple resterait
         sinon écrit dans le champ de gravure, prêt à partir en commande. */
      if (P.remember) P.remember(raw ? shown : '', current.font);
    }
    /* Rendu de secours : plaque sans fiche de gravure (réglages manuels du bloc). */
    function paintLegacy(raw) {
      if (overlay) {
        overlay.textContent = raw || overlay.getAttribute('data-placeholder') || '';
        overlay.classList.toggle('is-placeholder', !raw);
      }
      root.setAttribute('data-font', current.font);
      if (!overlay || !stage || !current.plaque) return;
      var base = parseFloat(current.plaque.getAttribute('data-size') || '5') / 100 * stage.clientWidth;
      var maxW = parseFloat(current.plaque.getAttribute('data-w') || '40') / 100 * stage.clientWidth;
      overlay.style.fontSize = base + 'px';
      var w = overlay.scrollWidth;
      if (w > maxW && w > 0) overlay.style.fontSize = Math.max(base * maxW / w, base * 0.45) + 'px';
      if (note) note.hidden = true;
    }
    /* Le texte part avec le client : dans l'adresse de la fiche, et dans la session pour tous les autres liens. */
    function linkFor(url, raw) {
      if (!url || !raw) return url;
      var t = P ? P.normalize(raw, current.font) : raw;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'g=' + encodeURIComponent(t) + '&f=' + encodeURIComponent(current.font);
    }
    function paint() {
      var raw = currentName();
      if (P && current.cfg) paintPerso(raw); else paintLegacy(raw);
      var url = current.plaque ? current.plaque.getAttribute('data-product-url') : '';
      goLinks.forEach(function (a) {
        if (a.hasAttribute('data-follow-plaque') && url) a.setAttribute('href', linkFor(url, raw));
      });
      if (grave) {
        document.documentElement.classList.toggle('lg-name', !!raw);
        if (chooseBtn) chooseBtn.hidden = !raw;
        document.dispatchEvent(new CustomEvent('bylivia:name', { detail: { raw: raw, font: current.font } }));
      }
    }
    function selectPlaque(el) {
      if (!el) return;
      current.plaque = el;
      current.cfg = null;
      var raw = el.getAttribute('data-config');
      if (P && raw) { try { current.cfg = JSON.parse(raw); } catch (err) { current.cfg = null; } }
      if (current.cfg && !current.cfg.preview) current.cfg = null;
      lastPlaqueId = el.getAttribute('data-plaque');
      try { sessionStorage.setItem('landing-plaque', lastPlaqueId); } catch (err) { /* ignore */ }
      plaques.forEach(function (p) { p.hidden = p !== el; });
      plaqueChips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-plaque-chip') === el.getAttribute('data-plaque') ? 'true' : 'false'); });
      /* Prénom d'exemple et prix : ceux du modèle affiché, pas ceux du premier de la liste. */
      var demo = el.getAttribute('data-demo-name') || defaultDemo;
      if (overlay) overlay.setAttribute('data-placeholder', demo);
      if (input) input.setAttribute('placeholder', demo);
      var price = el.getAttribute('data-price') || '';
      /* Promo datée : l'ancien prix barré devant le prix remisé (voir promo-prix). */
      var was = el.getAttribute('data-price-was') || '';
      if (modelPrice) {
        if (was) {
          var esc = function (t) { return t.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
          modelPrice.innerHTML = '<s class="promo-prix__old">' + esc(was) + '</s> <span class="promo-prix__new">' + esc(price) + '</span>';
        } else modelPrice.textContent = price;
      }
      if (modelLine) modelLine.hidden = !price;
      if (stickyPrice) stickyPrice.textContent = price || stickyDefault;
      if (overlay && stage) {
        if (current.cfg) {
          /* placeText pose lui-même la position, la taille et la teinte, au pixel près. */
          overlay.style.maxWidth = '';
        } else {
          overlay.style.left = el.getAttribute('data-x') + '%';
          overlay.style.top = el.getAttribute('data-y') + '%';
          overlay.style.maxWidth = el.getAttribute('data-w') + '%';
          overlay.style.fontFamily = '';
          overlay.style.fontSize = (parseFloat(el.getAttribute('data-size') || '5') / 100 * stage.clientWidth) + 'px';
          overlay.style.transform = 'translate(-50%, -50%) rotate(' + (el.getAttribute('data-rotate') || 0) + 'deg)';
          overlay.setAttribute('data-tone', el.getAttribute('data-tone') || 'light');
        }
      }
      paint();
    }
    plaqueChips.forEach(function (c) {
      c.addEventListener('click', function () {
        var key = c.getAttribute('data-plaque-chip');
        selectPlaque(plaques.filter(function (p) { return p.getAttribute('data-plaque') === key; })[0]);
      });
    });
    fontChips.forEach(function (c) {
      c.addEventListener('click', function () {
        current.font = c.getAttribute('data-font-chip');
        fontChips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        paint();
      });
      if (c.getAttribute('data-font-chip') === current.font) c.setAttribute('aria-pressed', 'true');
    });
    if (input) {
      input.addEventListener('input', function () {
        var clean = P ? P.sanitize(input.value) : input.value;
        if (clean.length > maxLen) clean = clean.slice(0, maxLen);
        if (clean !== input.value) {
          var pos = (input.selectionStart || clean.length) - (input.value.length - clean.length);
          input.value = clean;
          try { input.setSelectionRange(pos, pos); } catch (err) { /* champ non focalisé */ }
        }
        paint();
      });
    }
    window.addEventListener('resize', function () { if (current.plaque) selectPlaque(current.plaque); });

    /* Date de livraison estimée */
    var ship = addBusinessDays(orderDate(), shipDays);
    var deliv = addBusinessDays(ship, transitDays);
    Array.prototype.forEach.call(document.querySelectorAll('[data-delivery-date]'), function (el) {
      el.textContent = fmtDate(deliv);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ship-date]'), function (el) {
      el.textContent = fmtDate(ship);
    });

    /* Parcours gravure : avec un prénom, les boutons descendent aux modèles (et les font briller) ;
       sans, ils remontent au champ et l'activent (clavier ouvert sur téléphone). */
    function scrollToModels() {
      var m = document.querySelector('[data-landing-models]');
      if (!m) return;
      m.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var g = m.querySelector('.lmodels__grid');
      if (g) {
        g.classList.remove('is-nudge');
        void g.offsetWidth;
        g.classList.add('is-nudge');
        window.setTimeout(function () { g.classList.remove('is-nudge'); }, 2000);
      }
      window.setTimeout(function () { document.dispatchEvent(new CustomEvent('lp:scrolled')); }, 900);
    }
    function goToInput() {
      if (!input) return;
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (grave) {
      [chooseBtn].concat(Array.prototype.slice.call(document.querySelectorAll('[data-name-cta]'))).forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (currentName()) scrollToModels(); else goToInput();
        });
      });
    }

    /* Barre fixe : visible dès l'arrivée, sauf quand le bouton du hero est lui-même à l'écran
       (97 % des visiteurs sont sur téléphone : il faut une action possible sans défiler). */
    var sticky = document.querySelector('[data-landing-sticky]');
    var heroCta = root.querySelector('[data-hero-cta]');
    if (sticky && heroCta) {
      var ticking = false;
      var models = grave ? document.querySelector('[data-landing-models]') : null;
      var updateSticky = function () {
        ticking = false;
        var r = heroCta.getBoundingClientRect();
        sticky.classList.toggle('is-visible', r.bottom < 0 || r.top > window.innerHeight);
        /* Flèches vers les modèles : en bas tant qu'on est au-dessus, en haut ensuite. */
        if (models) sticky.setAttribute('data-dir', models.getBoundingClientRect().top > window.innerHeight * 0.55 ? 'down' : 'up');
      };
      if (models) {
        window.addEventListener('scrollend', updateSticky, { passive: true });
        document.addEventListener('lp:scrolled', updateSticky);
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(updateSticky); }
      }, { passive: true });
      updateSticky();
    }

    /* Éditeur de thème : quand on clique un bloc « Plaque vierge », l'aperçu bascule sur cette plaque. */
    root.addEventListener('shopify:block:select', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-plaque]') : null;
      if (el) selectPlaque(el);
    });

    /* L'annonce dit « pour elle » : la page doit ouvrir sur une gourmette femme, pas sur la
       première plaque. Le paramètre ?pour= pilote donc aussi le simulateur, comme il pilote déjà
       la grille des modèles plus bas. */
    var segment = '';
    try { segment = (new URLSearchParams(window.location.search).get('pour') || '').toLowerCase(); } catch (err) { segment = ''; }
    var wanted = segment ? plaques.filter(function (p) { return p.getAttribute('data-segment') === segment; })[0] : null;
    /* Le sur-titre parle au bon public : « Gourmette femme gravée » quand l'annonce disait « pour elle ». */
    if (wanted && eyebrow && wanted.getAttribute('data-eyebrow')) eyebrow.textContent = wanted.getAttribute('data-eyebrow');

    /* Après un re-rendu de la section ou un rechargement de l'aperçu (éditeur), on garde la plaque affichée. */
    if (!wanted) {
      var wantedId = lastPlaqueId;
      if (!wantedId) { try { wantedId = sessionStorage.getItem('landing-plaque'); } catch (err) { wantedId = null; } }
      wanted = plaques.filter(function (p) { return p.getAttribute('data-plaque') === wantedId; })[0];
    }
    selectPlaque(wanted || plaques[0]);
    /* Les polices doivent être chargées pour que la mesure du texte soit juste. */
    function ready() { fontsReady = true; paint(); }
    if (P && P.loadFonts) P.loadFonts().then(ready, ready); else ready();
  }

  /* ---------- Simulateur photo (pendentifs) ----------
     Même rendu que la fiche produit : le moteur de l'éditeur (perso-photo.js › byliviaPhoto.viewer)
     dessine la photo gravée dans le gabarit du produit relié (cadre, plaque, masque, teinte).
     La photo reste dans le navigateur ; byliviaPhoto.handoff la met de côté pour que la fiche
     l'affiche déjà en place quand le client y arrive. */
  function initPhotoHero(root) {
    var PH = window.byliviaPhoto;
    var shipDays = parseInt(root.getAttribute('data-ship-days') || '2', 10);
    var transitDays = parseInt(root.getAttribute('data-transit-days') || '3', 10);
    var stage = root.querySelector('[data-stage]');
    var hint = root.querySelector('[data-photo-hint]');
    var badge = root.querySelector('[data-photo-badge]');
    var input = root.querySelector('[data-photo-input]');
    var drop = root.querySelector('[data-photo-drop]');
    var reset = root.querySelector('[data-photo-reset]');
    var footnote = root.querySelector('[data-footnote]');
    var footnoteBase = footnote ? footnote.textContent : '';
    var badgeBase = badge ? badge.textContent : '';
    var plaques = Array.prototype.slice.call(root.querySelectorAll('[data-plaque]'));
    var plaqueChips = Array.prototype.slice.call(root.querySelectorAll('[data-plaque-chip]'));
    var goLinks = Array.prototype.slice.call(document.querySelectorAll('[data-landing-go]'));
    var current = { plaque: null, work: null, mine: false, fresh: false }; /* mine : photo du client (sinon : exemple) ; fresh : à graver sous les yeux */
    var viewers = {};
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var fx = { el: null, ctrl: null };
    var pickFrom = null; /* 'remote' : photo choisie depuis la barre fixe ou l'appel final */
    /* La photo du visiteur est gravée : partout sur la page, « Essayez avec votre photo » devient
       « Choisissez votre pendentif » (éléments data-when, classe lp-photo sur <html>). */
    function markPhoto() { document.documentElement.classList.toggle('lp-photo', !!current.mine); }
    /* Fin d'une gravure : seule celle de la photo encore affichée met le bouton à jour (une gravure
       de l'exemple interrompue par l'envoi d'une photo ne doit pas le basculer trop tôt). */
    function markFor(mine) { return function () { if (!!mine === !!current.mine) markPhoto(); }; }
    /* Descend (ou remonte) à la grille, puis fait briller les cartes un instant : même quand la
       grille est déjà à l'écran, le bouton a un effet visible. */
    function scrollToModels() {
      var m = document.querySelector('[data-landing-models]');
      if (!m) return;
      m.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var grid = m.querySelector('.lmodels__grid');
      if (!grid || reduce) return;
      grid.classList.remove('is-nudge');
      void grid.offsetWidth;
      grid.classList.add('is-nudge');
      window.setTimeout(function () { grid.classList.remove('is-nudge'); }, 2000);
      window.setTimeout(function () { document.dispatchEvent(new CustomEvent('lp:scrolled')); }, 900);
    }

    /* Interrompt la gravure en cours : la plaque reprend aussitôt sa photo gravée. */
    function stopFx() {
      if (!fx.ctrl) return;
      var ctrl = fx.ctrl;
      fx.ctrl = null; fx.el = null;
      ctrl.stop();
    }
    /* « Moment gravure » (≈ 3 s) : moteur commun, perso-photo.js › reveal. */
    function engrave(el, v, work, done) {
      stopFx();
      fx.el = el;
      fx.ctrl = PH.reveal(el.querySelector('[data-photo-canvas]'), v, work, function () {
        fx.el = null; fx.ctrl = null;
        if (done) done();
      });
    }

    function cfgOf(el) {
      try { return JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { return {}; }
    }
    /* Photo d'ambiance : zone gravée en % de l'image (x, y, largeur, hauteur, arrondi, trou x, y, rayon). */
    function sceneOf(el) {
      var url = el.getAttribute('data-scene');
      var z = (el.getAttribute('data-scene-zone') || '').split(/[\s,;]+/).map(parseFloat).filter(function (n) { return !isNaN(n); });
      return url && z.length >= 4 ? { url: url, zone: z, mask: el.getAttribute('data-scene-mask') || null } : null;
    }
    function viewerFor(el) {
      var id = el.getAttribute('data-plaque');
      if (!viewers[id] && PH && (el.getAttribute('data-frame') || el.getAttribute('data-scene'))) {
        var v = PH.viewer(el.querySelector('[data-photo-canvas]'), {
          frame: el.getAttribute('data-frame'), plate: el.getAttribute('data-plate'), mask: el.getAttribute('data-mask'),
          scene: sceneOf(el), cfg: cfgOf(el)
        });
        viewers[id] = v;
        v.ready.then(function () { if (current.plaque === el) show(); });
      }
      return viewers[id] || null;
    }
    /* La zone « Votre photo ici » se pose sur la zone gravable (gabarit ou photo d'ambiance). */
    function placeHint(el) {
      if (!hint) return;
      var sc = sceneOf(el);
      if (sc) {
        var q = sc.zone;
        hint.style.setProperty('--zx', q[0] + q[2] / 2 + '%');
        hint.style.setProperty('--zy', q[1] + q[3] / 2 + '%');
        hint.style.setProperty('--zw', q[2] + '%');
        hint.style.setProperty('--zh', q[3] + '%');
        var fam = cfgOf(el).family;
        hint.setAttribute('data-shape', sc.mask && fam === 'rond' ? 'circle' : sc.mask && fam === 'coeur' ? 'heart' : 'rect');
        return;
      }
      var cfg = cfgOf(el), z = cfg.zone, f = cfg.frame_px;
      if (!z || !f) return;
      hint.style.setProperty('--zx', (z.x + z.w / 2) / f.w * 100 + '%');
      hint.style.setProperty('--zy', (z.y + z.h / 2) / f.h * 100 + '%');
      hint.style.setProperty('--zw', z.w / f.w * 100 + '%');
      hint.style.setProperty('--zh', z.h / f.h * 100 + '%');
      hint.setAttribute('data-shape', cfg.family === 'rond' ? 'circle' : cfg.family === 'coeur' ? 'heart' : 'rect');
    }
    function show() {
      var el = current.plaque;
      if (!el) return;
      var v = viewerFor(el);
      if (v) {
        if (fx.el && fx.el !== el) stopFx();
        if (current.fresh && current.work && !reduce && PH.reveal) { current.fresh = false; engrave(el, v, current.work, markFor(current.mine)); }
        else {
          if (fx.el !== el) v.setPhoto(current.work);
          markPhoto();
        }
      }
      placeHint(el);
      if (stage) stage.classList.toggle('has-photo', current.mine);
      if (hint) hint.hidden = !!current.work;
      /* Étiquette sur le pendentif : « Exemple… » ou « Votre photo » (y compris quand la page
         reprend la photo déjà ajoutée pendant la visite). */
      if (badge) {
        badge.hidden = !current.work;
        badge.textContent = current.mine ? badge.getAttribute('data-mine') || 'Votre photo' : badgeBase;
        badge.classList.toggle('is-mine', !!current.mine);
      }
      if (reset) reset.hidden = !current.mine;
      if (footnote) footnote.textContent = current.mine && footnote.getAttribute('data-footnote-photo') ? footnote.getAttribute('data-footnote-photo') : footnoteBase;
    }
    function selectPlaque(el) {
      if (!el) return;
      current.plaque = el;
      lastPlaqueId = el.getAttribute('data-plaque');
      try { sessionStorage.setItem('landing-plaque', lastPlaqueId); } catch (err) { /* ignore */ }
      plaques.forEach(function (p) { p.hidden = p !== el; });
      plaqueChips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-plaque-chip') === el.getAttribute('data-plaque') ? 'true' : 'false'); });
      var url = el.getAttribute('data-product-url');
      goLinks.forEach(function (a) { if (a.hasAttribute('data-follow-plaque') && url) a.setAttribute('href', url); });
      show();
    }
    function loadFile(file, fromHandoff) {
      if (!file || !PH) return;
      PH.readPhoto(file).then(function (work) {
        current.work = work; current.mine = true; current.fresh = true;
        show();
        if (!fromHandoff) PH.handoff.save(file);
        /* Photo choisie depuis le bas de page : on remonte voir la pointe la graver. */
        if (pickFrom === 'remote' && stage) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        pickFrom = null;
        /* La section animée de la page rejoue avec cette photo. */
        document.dispatchEvent(new CustomEvent('bylivia:photo', { detail: { work: work } }));
      }).catch(function () { /* format illisible ici (HEIC) : la fiche proposera de le reprendre */ });
    }
    /* L'exemple : sa version détourée si elle existe (seul le sujet est gravé, comme à l'atelier). */
    function loadDemo() {
      var url = root.getAttribute('data-demo-cutout') || root.getAttribute('data-demo');
      if (!url) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (current.mine) return;
        var c = document.createElement('canvas');
        var r = Math.min(1, 1400 / Math.max(img.naturalWidth, img.naturalHeight));
        c.width = Math.round(img.naturalWidth * r); c.height = Math.round(img.naturalHeight * r);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        current.work = c; current.mine = false; current.fresh = true;
        show();
      };
      img.src = url;
    }
    function pick(remote) { if (input) { pickFrom = remote ? 'remote' : null; input.value = ''; input.click(); } }

    plaqueChips.forEach(function (c) {
      c.addEventListener('click', function () {
        var key = c.getAttribute('data-plaque-chip');
        selectPlaque(plaques.filter(function (p) { return p.getAttribute('data-plaque') === key; })[0]);
      });
    });
    if (input) input.addEventListener('change', function () { loadFile(input.files && input.files[0]); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-photo-pick]'), function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); pick(); });
    });
    /* Toucher le pendentif = choisir sa photo, tant que ce n'est pas la sienne. */
    if (stage) stage.addEventListener('click', function () { if (!current.mine) pick(); });
    [drop, stage].forEach(function (zone) {
      if (!zone) return;
      ['dragenter', 'dragover'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.remove('is-over'); }); });
      zone.addEventListener('drop', function (e) { loadFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    });
    /* Bouton principal (haut de page, barre fixe, appel final) : sans photo, il ouvre le choix de
       la photo ; une fois la photo gravée, il descend aux modèles. Sans moteur : simple lien. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-photo-cta]'), function (b) {
      b.addEventListener('click', function (e) {
        if (!PH || !input) return;
        e.preventDefault();
        if (document.documentElement.classList.contains('lp-photo')) scrollToModels();
        else pick(b.hasAttribute('data-photo-remote'));
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-photo-again]'), function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); pick(false); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-photo-browse]'), function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); scrollToModels(); });
    });
    if (reset) reset.addEventListener('click', function () {
      stopFx();
      current.work = null; current.mine = false;
      if (input) input.value = '';
      if (PH) PH.handoff.clear();
      show();
      loadDemo();
      document.dispatchEvent(new CustomEvent('bylivia:photo-clear'));
    });

    var ship = addBusinessDays(orderDate(), shipDays);
    var deliv = addBusinessDays(ship, transitDays);
    Array.prototype.forEach.call(document.querySelectorAll('[data-delivery-date]'), function (el) { el.textContent = fmtDate(deliv); });

    var sticky = document.querySelector('[data-landing-sticky]');
    var heroCta = root.querySelector('[data-hero-cta]');
    if (sticky && heroCta) {
      var ticking = false;
      var models = document.querySelector('[data-landing-models]');
      var updateSticky = function () {
        ticking = false;
        sticky.classList.toggle('is-visible', heroCta.getBoundingClientRect().bottom < 0);
        /* Les flèches du bouton pointent vers les cartes : en bas tant qu'on est au-dessus de la
           grille, en haut dès qu'elle est à l'écran (ou dépassée). */
        if (models) sticky.setAttribute('data-dir', models.getBoundingClientRect().top > window.innerHeight * 0.55 ? 'down' : 'up');
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(updateSticky); } }, { passive: true });
      /* Fin de défilement (doigt ou saut de page) : position définitive des flèches. */
      window.addEventListener('scrollend', updateSticky, { passive: true });
      document.addEventListener('lp:scrolled', updateSticky);
      updateSticky();
    }
    root.addEventListener('shopify:block:select', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-plaque]') : null;
      if (el) selectPlaque(el);
    });
    var wantedId = lastPlaqueId;
    if (!wantedId) { try { wantedId = sessionStorage.getItem('landing-plaque'); } catch (err) { wantedId = null; } }
    var remembered = plaques.filter(function (p) { return p.getAttribute('data-plaque') === wantedId; })[0];
    selectPlaque(remembered || plaques[0]);
    /* Retour sur la landing : la photo déjà déposée reprend sa place ; sinon, l'exemple. */
    if (PH) PH.handoff.take().then(function (f) { if (f && !current.mine) loadFile(f, true); else if (!f) loadDemo(); });
    else loadDemo();
  }

  /* ---------- Filtres de la grille ---------- */
  function initModels(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-segment]'));
    if (!chips.length) return;
    function apply(seg) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-filter') === seg ? 'true' : 'false'); });
      cards.forEach(function (card) {
        var segs = (card.getAttribute('data-segment') || '').split(' ');
        card.hidden = !(seg === 'tous' || segs.indexOf(seg) > -1);
      });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.getAttribute('data-filter')); }); });
    var param = '';
    try { param = (new URLSearchParams(window.location.search).get('pour') || '').toLowerCase(); } catch (e) { /* ignore */ }
    var wanted = chips.some(function (c) { return c.getAttribute('data-filter') === param; }) ? param : (root.getAttribute('data-default-filter') || 'tous');
    apply(wanted);
  }

  /* Grille des modèles (landing pendentifs) : dès que le visiteur a ajouté SA photo dans le hero
     (ou qu'elle revient d'une fiche), chaque modèle l'affiche gravée sur sa photo d'ambiance, comme
     la page collection. Sans photo, les cartes gardent la vraie photo produit. Rendu carte par
     carte à l'approche de l'écran ; au survol (ordinateur), la photo produit réapparaît. */
  /* Cartes « forme » : la pastille de finition change la photo, les avis, le prix et le lien. */
  function initFormes(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-lforme]'), function (card) {
      if (card.__lforme) return;
      card.__lforme = true;
      var picks = Array.prototype.slice.call(card.querySelectorAll('[data-lforme-pick]'));
      var parts = Array.prototype.slice.call(card.querySelectorAll('[data-lforme-v]'));
      var links = Array.prototype.slice.call(card.querySelectorAll('[data-lforme-link]'));
      picks.forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-lforme-pick');
          picks.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          parts.forEach(function (p) { p.hidden = p.getAttribute('data-lforme-v') !== k; });
          links.forEach(function (a) { a.setAttribute('href', b.getAttribute('data-url')); });
          card.dispatchEvent(new CustomEvent('lforme:pick', { bubbles: true }));
        });
      });
    });
  }

  function initModelsPhoto(root) {
    var PH = window.byliviaPhoto;
    var photos = Array.prototype.slice.call(root.querySelectorAll('[data-lmodel-photo]'));
    if (!PH || !photos.length || root.__lmodelsPhoto) return;
    root.__lmodelsPhoto = true;
    var note = root.querySelector('[data-lmodels-note]');
    var work = null;
    /* Une carte « forme » = toutes ses finitions : dessinées ensemble dès que la carte approche,
       pour qu'une pastille montre aussitôt la simulation (jamais la photo produit). */
    var boxes = [];
    photos.forEach(function (el) { var bx = el.closest('[data-lforme]') || el; if (boxes.indexOf(bx) < 0) boxes.push(bx); });
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.__lmSeen = true;
        renderBox(e.target);
      });
    }, { rootMargin: '300px 0px' }) : null;
    function attr(el, k) { return el.getAttribute(k); }
    function photosOf(bx) { return bx.hasAttribute('data-lmodel-photo') ? [bx] : Array.prototype.slice.call(bx.querySelectorAll('[data-lmodel-photo]')); }
    function renderBox(bx) { photosOf(bx).forEach(render); }
    function render(el) {
      if (!work || el._lmWork === work) return;
      if (!el._lm) {
        var z = (attr(el, 'data-scene-zone') || '').split(/[\s,;]+/).map(parseFloat).filter(function (n) { return !isNaN(n); });
        var cfg = {};
        try { cfg = JSON.parse(attr(el, 'data-config') || '{}'); } catch (e) { cfg = {}; }
        el._lm = PH.viewer(el.querySelector('canvas'), { scene: { url: attr(el, 'data-scene'), zone: z, mask: attr(el, 'data-scene-mask') }, cfg: cfg });
      }
      var v = el._lm, w = work;
      el._lmWork = w;
      v.ready.then(function () { if (work !== w) return; v.setPhoto(w); el.classList.add('is-on'); }, function () { el._lmWork = null; });
    }
    function apply() {
      root.classList.toggle('has-visitor-photo', !!work);
      if (!work) photos.forEach(function (el) { el.classList.remove('is-on'); el._lmWork = null; });
      else boxes.forEach(function (bx) { if (bx.__lmSeen || !io) renderBox(bx); else io.observe(bx); });
      if (note) note.hidden = !work;
    }
    function shrink(c) {
      var r = Math.min(1, 800 / Math.max(c.width, c.height));
      if (r === 1) return c;
      var s = document.createElement('canvas');
      s.width = Math.round(c.width * r); s.height = Math.round(c.height * r);
      var g = s.getContext('2d');
      g.imageSmoothingQuality = 'high';
      g.drawImage(c, 0, 0, s.width, s.height);
      return s;
    }
    document.addEventListener('bylivia:photo', function (e) { if (e.detail && e.detail.work) { work = shrink(e.detail.work); apply(); } });
    document.addEventListener('bylivia:photo-clear', function () { work = null; apply(); });
  }

  /* Landing gourmettes (variante A) : le prénom tapé dans le hero est gravé sur la plaque vierge
     de CHAQUE modèle (même moteur que la fiche) ; un modèle où il ne tiendrait pas lisiblement
     s'estompe. Les liens emportent le prénom (?g= &f=). */
  function initModelsName(root) {
    var P = window.byliviaPerso;
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-lcard-name]'));
    if (!P || !layers.length || root.__lmName) return;
    root.__lmName = true;
    var note = root.querySelector('[data-lmodels-name-note]');
    var ctx = document.createElement('canvas').getContext('2d');
    var items = layers.map(function (el) {
      var cfg = {};
      try { cfg = JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
      var card = el.closest('a');
      return { el: el, cfg: cfg, d: P.dims(cfg), img: el.querySelector('img'), overlay: el.querySelector('[data-perso-overlay]'), card: card, href: card ? card.getAttribute('href') : '' };
    });
    var last = { raw: '', font: 'kaushan' }, loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      items.forEach(function (it) {
        if (!it.img || it.img.getAttribute('src')) return;
        it.img.addEventListener('load', function () { paint(last.raw, last.font); });
        it.img.setAttribute('src', it.img.getAttribute('data-src'));
      });
    }
    function paint(raw, font) {
      last = { raw: raw, font: font };
      if (raw) load();
      var f = P.FONTS[font] || P.FONTS.kaushan;
      var text = P.normalize(raw || '', font);
      items.forEach(function (it) {
        if (!raw) {
          it.el.classList.remove('is-on');
          if (it.card) { it.card.classList.remove('is-dim'); it.card.setAttribute('href', it.href); }
          return;
        }
        var r = P.fit(ctx, text, f.css, it.d.zoneW, it.d.zoneH, it.d.ppm);
        var ok = r.capMm >= it.d.minMm;
        var ready = it.img && it.img.complete && it.img.naturalWidth > 0;
        if (ok && ready) P.placeText({ stage: it.el, overlay: it.overlay, img: it.img }, it.cfg.preview || {}, it.d, r, f, text);
        it.el.classList.toggle('is-on', ok && ready);
        if (it.card) {
          it.card.classList.toggle('is-dim', !ok);
          it.card.setAttribute('href', ok && it.href ? it.href + (it.href.indexOf('?') > -1 ? '&' : '?') + 'g=' + encodeURIComponent(text) + '&f=' + encodeURIComponent(font) : it.href);
        }
      });
      if (note) note.hidden = !raw;
    }
    document.addEventListener('bylivia:name', function (e) { if (e.detail) paint(e.detail.raw, e.detail.font); });
    window.addEventListener('resize', function () { if (last.raw) paint(last.raw, last.font); });
  }

  function boot(scope) {
    var root = scope || document;
    /* La grille écoute le prénom du hero : elle s'initialise d'abord. */
    Array.prototype.forEach.call(root.querySelectorAll('[data-landing-models]'), initModelsName);
    Array.prototype.forEach.call(root.querySelectorAll('[data-landing-hero]'), initHero);
    Array.prototype.forEach.call(root.querySelectorAll('[data-landing-models]'), initFormes);
    Array.prototype.forEach.call(root.querySelectorAll('[data-landing-models]'), initModelsPhoto);
    Array.prototype.forEach.call(root.querySelectorAll('[data-landing-photo]'), initPhotoHero);
    Array.prototype.forEach.call(root.querySelectorAll('[data-landing-models]'), initModels);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();

  /* Éditeur de thème : une section modifiée est re-rendue, on la ré-initialise. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
